// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mOmtHFPQaXCnfnK2\\+bsjiA\\=\\={position:absolute;width:100%;top:56px;z-index:9;opacity:.4}html[dir] .mOmtHFPQaXCnfnK2\\+bsjiA\\=\\={-webkit-transition:opacity .267s ease-in;transition:opacity .267s ease-in}.POqXBkykj9337qc8\\+b\\+rQQ\\=\\={opacity:1}", ""]);
// Exports
exports.locals = {
	"readingPaneContainer": "mOmtHFPQaXCnfnK2+bsjiA==",
	"readingPaneContainer--shown": "POqXBkykj9337qc8+b+rQQ=="
};
module.exports = exports;
